import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { RoleService } from '../services/api/role.service';
import { GlobalService } from '../services/ui/global.service';

export const permissionGuard: CanActivateFn = (route, state) => {
  let _globalService = inject(GlobalService);
  let _roleService = inject(RoleService);
  let router = inject(Router);

  return _globalService.profile.pipe(
    take(1),
    map((profile) => {
      if (profile?.roleId?.permissions) {
        const permissions: string[] = _roleService.getIdsWithTrueStatus(
          profile.roleId.permissions
        );

        const requiredPermission = route.data['permission'] as string;

        if (permissions.includes(requiredPermission)) {
          return true;
        }
      }

      router.navigate(['/profile/profile-detail']);
      return false;
    })
  );
};
